import { render } from "./ChatInput.vue?vue&type=template&id=4a4bf18c&scoped=true"
import script from "./ChatInput.vue?vue&type=script&lang=ts"
export * from "./ChatInput.vue?vue&type=script&lang=ts"

import "./ChatInput.vue?vue&type=style&index=0&id=4a4bf18c&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-4a4bf18c"

export default script